<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Ficha complementar - Inconsistências"
    >
        <template v-if="data">
            <Inconsistencia
                v-if="inconsistenciaVersao"
                :inconsistencias="inconsistenciaVersao"
            />
            <rkm-area
                title="Cadastro"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Profissional"
                            :value="data.cadastro.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNS"
                            :value="data.cadastro.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNES"
                            :value="data.cadastro.campos.cnes"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.cadastro.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="INE"
                            :value="data.cadastro.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="CBO"
                            :value="data.cadastro.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Data"
                            :value="data.cadastro.campos.dataAtendimento"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Turno"
                            :value="data.cadastro.campos.turno"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                </rkm-row>

                <Inconsistencia :inconsistencias="data.cadastro.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Paciente"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.paciente.campos.nomeCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNS"
                            :value="data.paciente.campos.cnsCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CPF"
                            :value="data.paciente.campos.cpfCidadao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-area title="Responsável familiar">
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                label="Nome"
                                :value="data.paciente.campos.nomeResponsavelFamiliar"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="CNS"
                                :value="data.paciente.campos.cnsResponsavelFamiliar"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="CPF"
                                :value="data.paciente.campos.cpfResponsavelFamiliar"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <Inconsistencia :inconsistencias="data.paciente.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Exames"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Teste do Olhinho"
                            :value="data.exames.campos.dataRealizacaoTesteOlhinho"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Resultado - Teste do Olhinho"
                            :value="data.exames.campos.coResultadoTesteOlhinho"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Fundo de olho"
                            :value="data.exames.campos.dataRealizacaoExameFundoOlho"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Resultado - Fundo de olho"
                            :value="data.exames.campos.coResultadoExameFundoOlho"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Teste da Orelhinha"
                            :value="data.exames.campos.dataRealizacaoTesteOrelhinha"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Resultado - Teste da Orelhinha"
                            :value="data.exames.campos.coResultadoTesteOrelhinha"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="US Transfontanela"
                            :value="data.exames.campos.dataRealizacaoUSTransfontanela"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Resultado - US Transfontanela"
                            :value="data.exames.campos.coResultadoUsTransfontanela"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Tomografia Computadorizada"
                            :value="data.exames.campos.dataRealizacaoTomografiaComputadorizada"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Resultado - Tomografia Computadorizada"
                            :value="data.exames.campos.coResultadoTomografiaComputadorizada"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Ressonância Magnética"
                            :value="data.exames.campos.dataRealizacaoRessonanciaMagnetica"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Resultado - Ressonância Magnética"
                            :value="data.exames.campos.coResultadoRessonanciaMagnetica"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.exames.inconsistencias" />
            </rkm-area>
        </template>


        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        inconsistenciaVersao(){
            
            const texto = this.inconsistencia?.inconsistencia || ''
    
            const versaoErro = this.extrairVersaoDescricao(texto)
            const versao = this.extrairVersao(texto)

            if(!versaoErro) return []

            return [
                `A versão atual do LEDI (${versao}) não é compatível com a versão do seu integrador.`        
            ]
        
        },
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        extrairVersaoDescricao(texto) {

            if (!texto) return null

            texto = texto.replace(/\\u00e3/g, 'ã')

            const match = texto.match(/vers[aã]o\s+([\d.]+)\s+inexistente/i)

            return match ? match[1] : null
        },
    
        extrairVersao(texto){

            if (!texto) return null

            const match = texto.match(/\d+\.\d+\.\d+/)

            return match ? match[0] : null
        }
    },
    mixins: [repository, error]
}
</script>